const isValidString = (value) => {
    return (
        typeof value === 'string'
        || value === undefined
        || value === null
    );
}

const isValidNonEmptyString = (value) => {
    return (
        typeof value === 'string'
        && value !== ''
    );
}

const isValidEmptyObject = (value) => {
    return (
        JSON.stringify(value) === JSON.stringify({})
        || value === null
    );
}

const isValidNonNullEmptyObject = (value) => {
    return (
        JSON.stringify(value) === JSON.stringify({})
    );
}

const isValidNonEmptyBase64 = (value) => {
    if (!isValidNonEmptyString(value)) return false;
    const splits = value.split('base64,');
    if (
        !splits[1] 
        || !isValidNonEmptyString(splits[1])
    ) {
        return false;
    }
    try {
        Buffer.from(value, 'base64').toString('base64');
    } catch (error) {
        return false;
    }

    return true;
}

const isValidBase64String = (value) => {
    if (value === null || value === undefined || value === '') return true;
    else {
        return isValidNonEmptyBase64(value);
    }
}

const isValidIzvidFile = (value) => {
    const splits = value.split('base64,');
    if (
        !splits[1] 
        || !isValidNonEmptyString(splits[1])
    ) {
        return false;
    }

    return true;
}

const isNullOrUndefined = (value) => {
    return value === null || value === undefined;
}

const isValidInteger = (value) => {
    if (isNullOrUndefined(value)) return true;
    return !isNaN(Number(value));
}

const isValidNonNullInteger = (value) => {
    if (isNullOrUndefined(value)) return false;
    return !isNaN(Number(value));
}

module.exports = {
    isValidString,
    isValidEmptyObject,
    isValidNonNullEmptyObject,
    isValidNonEmptyString,
    isValidIzvidFile,
    isValidBase64String,
    isValidNonEmptyBase64,
    isNullOrUndefined,
    isValidInteger,
    isValidNonNullInteger,
}
